import { Dice2Icon } from './Dice2Icon';

/**
 * author: Yasmina Lembachar
 * id 07927207-23B1-4A93-BB8A-E6B5F41B919A
 * name dice-2
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dice-2.svg
 * tags
 * - Gaming / RPG 
 */
export const DiceTwoIcon = Dice2Icon;
export default DiceTwoIcon